// extracted by mini-css-extract-plugin
export default {"custom_text_area":"styles_custom_text_area__oRTcw"};